export var CONTENT_TYPE_APPLICATION_JSON = "application/json";
export var DEFAULT_CLIENT_TIMEOUT_MS = 68000;
export var DEFAULT_MAX_ATTEMPTS = 3;
export var RETRY_DELAY_MS = 3;
export var XSRF_HEADER = "x-smar-xsrf";
export var WEB2RAPI_SERVICE = "WEB2RAPI";
export var DESKTOP_TYPE = {
    FULL_DESKTOP: 1,
    PUBLISH: 2,
    UPDATE: 3,
    GADGET: 4,
    CELL_SELECTOR: 5,
    EMBED: 6
};
//# sourceMappingURL=constants.js.map